import script from "./AllApp.vue?vue&type=script&lang=ts&setup=true"
export * from "./AllApp.vue?vue&type=script&lang=ts&setup=true"

import "./AllApp.vue?vue&type=style&index=0&id=0cea086c&scoped=true&lang=less"
import "./AllApp.vue?vue&type=style&index=1&id=0cea086c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cea086c"]])

export default __exports__